import { z } from 'zod';

export const processActionTypeValues = [
  'send',
  'accept',
  'decline',
  'expire',
  'send-fails',
] as const;
export const processActionTypeSchema = z.enum(processActionTypeValues);
export type ProcessActionType = z.infer<typeof processActionTypeSchema>;

// The transition map keys are either a current operation-status UUID or the
// wildcard `'*'` (apply regardless of current status). Values are the target
// operation-status UUID.
const transitionMapSchema = z.record(z.string().min(1), z.uuid());

export const processActionConfigSchema = z
  .object({
    send: transitionMapSchema.optional(),
    accept: transitionMapSchema.optional(),
    decline: transitionMapSchema.optional(),
    expire: transitionMapSchema.optional(),
    'send-fails': transitionMapSchema.optional(),
  })
  .loose();
export type ProcessActionConfig = z.infer<typeof processActionConfigSchema>;

export const processActionItemSchema = z.object({
  id: z.uuid(),
  title: z.string().nullable(),
  config: processActionConfigSchema,
});
export type ProcessActionItem = z.infer<typeof processActionItemSchema>;

export const createProcessActionInput = z.object({
  title: z.string().nullable().optional(),
  config: processActionConfigSchema,
});
export type CreateProcessActionInput = z.infer<typeof createProcessActionInput>;

export const updateProcessActionInput = z.object({
  id: z.uuid(),
  title: z.string().nullable().optional(),
  config: processActionConfigSchema.optional(),
});
export type UpdateProcessActionInput = z.infer<typeof updateProcessActionInput>;

export const findProcessActionsInput = z.object({
  offset: z.number().int().nonnegative().optional(),
  limit: z.number().int().min(1).max(200).optional(),
  title: z.string().optional(),
});
export type FindProcessActionsInput = z.infer<typeof findProcessActionsInput>;

export const findProcessActionsResultSchema = z.object({
  data: z.array(processActionItemSchema),
  count: z.number().int().nonnegative(),
  countAll: z.number().int().nonnegative(),
});
export type FindProcessActionsResult = z.infer<
  typeof findProcessActionsResultSchema
>;

export const deleteProcessActionInput = z.object({ id: z.uuid() });
export type DeleteProcessActionInput = z.infer<typeof deleteProcessActionInput>;

export const deleteProcessActionResultSchema = z.object({ id: z.uuid() });
export type DeleteProcessActionResult = z.infer<
  typeof deleteProcessActionResultSchema
>;
